"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkButton = exports.knockoutButton = exports.outlineButton = exports.solidButton = void 0;

var _color = _interopRequireDefault(require("color"));

var _togaTheme = require("@thinkific/toga-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var white = (0, _color["default"])('white');

var solidButton = function solidButton(color) {
  if (!color || !(0, _togaTheme.isColor)(color)) {
    return null;
  }

  var amount = 0.1;
  var hoverColor = (0, _togaTheme.colorCanDarken)(color) ? (0, _color["default"])(color).darken(amount * 2).hex() : (0, _color["default"])(color).lighten(amount * 40).desaturate(0.15).hex();
  var activeColor = (0, _togaTheme.colorCanDarken)(color) ? (0, _color["default"])(color).darken(amount * 4).hex() : (0, _color["default"])(color).lighten(amount * 80).desaturate(0.4).hex();
  return "\n    background-color: ".concat(color, ";\n    color: ").concat((0, _togaTheme.accessibleTextColor)(color), ";\n    &:hover,\n    &:focus,\n    &.hover {\n      color: ").concat((0, _togaTheme.accessibleTextColor)(hoverColor), ";\n      background-color: ").concat(hoverColor, ";\n    }\n    &:active,\n    &.active {\n      color: ").concat((0, _togaTheme.accessibleTextColor)(activeColor), ";\n      background-color: ").concat(activeColor, ";\n    }\n  ");
};

exports.solidButton = solidButton;

var outlineButton = function outlineButton(color) {
  if (!color || !(0, _togaTheme.isColor)(color)) {
    return null;
  }

  var hoverBackground = (0, _togaTheme.colorCanLighten)(color) ? (0, _color["default"])(color).lighten(0.1).mix(white, 0.92).hex() : (0, _color["default"])(color).darken(0.3).mix(white, 0.85).hex();
  var activeBackground = (0, _togaTheme.colorCanLighten)(color) ? (0, _color["default"])(color).mix(white, 0.25).hex() : (0, _color["default"])(color).darken(0.2).mix(white, 0.4).hex();
  return "\n    border-color: ".concat(color, ";\n    color: ").concat((0, _togaTheme.accessibleTextColor)(color, 'white'), ";\n\n    &.hover,\n    &:hover,\n    &:focus {\n      background-color: ").concat(hoverBackground, ";\n      border-color: ").concat(color, ";\n      color: ").concat((0, _togaTheme.accessibleTextColor)(color, hoverBackground), ";\n\n      svg {\n        fill: ").concat((0, _togaTheme.accessibleTextColor)(color, 'white'), ";\n      }\n    }\n\n    &.active,\n    &:active {\n      background-color: ").concat(activeBackground, ";\n      border-color: ").concat(color, ";\n      color: ").concat((0, _togaTheme.accessibleTextColor)(activeBackground), ";\n\n      svg {\n        fill: white;\n      }\n    }\n\n    svg {\n      fill: ").concat((0, _togaTheme.accessibleTextColor)(color, 'white'), ";\n    }\n  ");
};

exports.outlineButton = outlineButton;

var knockoutButton = function knockoutButton(color) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'white';

  if (!color || !(0, _togaTheme.isColor)(color)) {
    return null;
  }

  return "\n    color: ".concat((0, _togaTheme.accessibleTextColor)(color, background), ";\n    border-color: transparent;\n    &.hover,\n    &:hover,\n    &:focus {\n      border-color: ").concat((0, _togaTheme.accessibleTextColor)(color, background), ";\n      color: ").concat((0, _togaTheme.accessibleTextColor)(color, background), ";\n\n      svg {\n        fill: ").concat((0, _togaTheme.accessibleTextColor)(color, background), ";\n      }\n    }\n    &.active,\n    &:active {\n      background-color: ").concat((0, _togaTheme.accessibleTextColor)(color, background), ";\n      border-color: ").concat((0, _togaTheme.accessibleTextColor)(color, background).darken(0.5), ";\n      color: #fff;\n\n      svg {\n        fill: white;\n      }\n    }\n\n    svg {\n      fill: ").concat((0, _togaTheme.accessibleTextColor)(color, background), ";\n    }\n  ");
};

exports.knockoutButton = knockoutButton;

var linkButton = function linkButton(color) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'white';

  if (!color || !(0, _togaTheme.isColor)(color)) {
    return null;
  }

  var foreground = (0, _togaTheme.accessibleTextColor)(color, background);
  return "\n    color: ".concat(foreground, ";\n    &.hover,\n    &:hover,\n    &:focus {\n      color: ").concat((0, _togaTheme.colorCanDarken)(foreground) ? foreground.darken(0.3) : foreground.lighten(0.1).mix(white, 0.15), ";\n    }\n    &.active,\n    &:active {\n      color: ").concat((0, _togaTheme.colorCanDarken)(foreground) ? foreground.darken(0.6) : foreground.lighten(0.15).mix(white, 0.3), ";\n    }\n  ");
};

exports.linkButton = linkButton;